/** @format */
import { Button, ButtonSize } from '@mpb-com/feather/components/atoms/button';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import { ThumbnailSkeleton } from '@mpb-com/feather/components/atoms/thumbnail/skeleton';
import React, { FunctionComponent } from 'react';

import { ProductComparisonItemInStockHeader } from './components/in-stock-header/in-stock-header.styles';
import {
    ProductComparisonItemContentSkeletonProps,
    ProductComparisonItemSkeletonProps,
} from './types';

export const ProductComparisonItemSkeleton: FunctionComponent<
    ProductComparisonItemSkeletonProps
> = ({ columnIndex, 'data-testid': dataTestId }) => {
    return (
        <ProductComparisonItemInStockHeader
            data-testid={dataTestId}
            $columnIndex={columnIndex}
            $rowIndex={0}
        >
            <ThumbnailSkeleton className="product-comparison-item-image" />
            <div className="product-comparison-item-details">
                <span className="product-comparison-item-price">
                    <Skeleton variant={SkeletonVariant.TEXT} width="40%" />
                </span>
                <Skeleton
                    className="product-comparison-item-condition"
                    variant={SkeletonVariant.TEXT}
                    width="75%"
                />
            </div>
            <Button
                className="product-comparison-item-button"
                size={ButtonSize.SMALL}
                isLoading
            />
        </ProductComparisonItemInStockHeader>
    );
};

function getRowLineCount(index: number, rowCount: number) {
    if (rowCount - index === 5) {
        return 6;
    }

    if (rowCount - index === 4) {
        return 2;
    }

    return 1;
}

export const ProductComparisonItemContentSkeleton = ({
    rowIndex,
    rowCount,
}: ProductComparisonItemContentSkeletonProps) => (
    <Skeleton
        variant={SkeletonVariant.TEXT}
        lineCount={getRowLineCount(rowIndex, rowCount)}
        width="50%"
    />
);
